import React, { useContext, useEffect, useState } from 'react'

import { Grid, LinearProgress } from '@material-ui/core'
import slugify from 'react-slugify/dist/slugify'
import {
  createPartner,
  createUnity,
  publishUnit,
  getPartnerById,
  getPartnerCitysMovies
} from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import {
  ParserPartnerCodesItens,
  ParserPartnerCodesItensInvert
} from '../../helpers/EventValuesHelper'

import { ParserTags } from '../../helpers/ParserHelper'

import Context from '../../context'
import { FORM_OBJECT, OBLIGATED_FIELDS } from '../../helpers/Variables'
import history from '../../services/history'

import AddressForm from '../../components/AddressForm'
import CompanyForm from '../../components/CompanyForm'
import ContactForm from '../../components/ContactForm'
import ContractForm from '../../components/ContractForm'
import EventsTypeDiscounts from '../../components/EventsTypeDiscounts'
import FormNavigation from '../../components/FormNavigation'
import ImageUploadToS3ge from '../../services/ImageUpload'

import changeLogo from '../../assets/images/altera-logo.png'
import PartnerData from '../../components/PartnerData'
import ToastMessages from '../../components/ToastMessages'

const { REACT_APP_IMAGES_URL } = process.env

function Partner() {
  const {
    editPartner,
    user,
    setUser,
    setAboutCurrentPage,
    openToast,
    setOpenToast,
    partnerToEdit
  } = useContext(Context)
  const [tags, setTags] = useState([])
  const [citys, setCitys] = useState([])
  const [showCitys, setShowCitys] = useState(false)
  const [responsibleList, setResponsibleList] = useState([])
  const [classificationList, setClassificationList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [showTags, setShowTags] = useState(false)

  const [steps, setSteps] = useState({
    step: 1,
    maxStep: 3
  })

  const [formObject, setFormObject] = useState(FORM_OBJECT)
  const [obligatedList, setObligatedList] = useState(OBLIGATED_FIELDS)

  const [latLong, setLatLong] = useState({
    lat: '',
    long: ''
  })

  const [newLogo, setNewLogo] = useState(changeLogo)
  const [newCover, setNewCover] = useState(changeLogo)
  const [iconLogo, setIconLogo] = useState(changeLogo)
  const [iconCover, setIconCover] = useState(changeLogo)
  const [crop, setCrop] = useState({
    aspect: 1 / 1,
    unit: '%',
    width: 50,
    height: 50,
    x: 25,
    y: 10
  })
  const [cropCover, setCropCover] = useState({
    aspect: 2 / 1,
    unit: '%',
    width: 50,
    height: 50,
    x: 25,
    y: 10
  })
  const [logoToUpload, setLogoToUpload] = useState(null)
  const [coverToUpload, setCoverToUpload] = useState(null)
  const [missInputs, setMissInputs] = useState(true)
  const [partnersCodesItens, setPartnersCodesItens] = useState([])

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Adicionar Parceiro',
      buttons: [{ title: 'Voltar', pathname: '/partnerslist' }]
    })
  }, [])

  async function partnerCitysMovies() {
    const result = await getPartnerCitysMovies()
    setCitys(result)
    console.log('partnerCitysMovies', result)
  }

  useEffect(() => {
    partnerCitysMovies()
  }, [editPartner])
  useEffect(() => {
    const tagsMovie = tags.includes(6)
    if (tagsMovie) {
      setShowCitys(true)
    }
  }, [tags])

  useEffect(() => {
    if (editPartner.id !== null) {
      getPartnerById(editPartner.id).then(r => {
        console.log('r: ', r)

        if (r) {
          const { partnerCodesItens } = r

          if (partnerCodesItens) {
            setPartnersCodesItens(ParserPartnerCodesItensInvert(partnerCodesItens))
          }

          setFormObject({ ...r })
          setNewLogo(`${REACT_APP_IMAGES_URL}${r.logo}`)
          setIconLogo(`${REACT_APP_IMAGES_URL}${r.logo}`)
          setNewCover(`${REACT_APP_IMAGES_URL}${r.cover}`)
          setIconCover(`${REACT_APP_IMAGES_URL}${r.cover}`)
          const { PartnerTags } = r

          if (PartnerTags) {
            const newArr = PartnerTags.map(tag => {
              return tag.tagsId
            })
            setTags([...newArr])
            setShowTags(true)
          }
          setIsLoading(false)
        }
      })
    } else {
      setFormObject(FORM_OBJECT)
      setShowTags(true)
      setIsLoading(false)
    }
  }, [editPartner])

  const handleContinue = async () => {
    if (steps.step < steps.maxStep) {
      setSteps({ ...steps, step: steps.step + 1 })
    }

    if (steps.step === steps.maxStep) {
      if (!formObject?.mainTag) {
        setOpenToast({
          open: true,
          message: 'Escolha uma categoria para o parceiro.',
          type: 'error'
        })
        return
      }
      setIsLoading(true)
      let logo = ''
      let cover = ''

      if (typeof logoToUpload !== 'string' || logoToUpload !== null) {
        try {
          logo = await ImageUploadToS3ge(logoToUpload)
        } catch (e) {
          console.log('Não conseguiu enviar a logo', e)
        }
      } else {
        logo = logoToUpload
      }
      if (typeof coverToUpload !== 'string' || coverToUpload !== null) {
        try {
          cover = await ImageUploadToS3ge(coverToUpload)
        } catch (e) {
          console.log('Não conseguiu enviar a capa', e)
        }
      } else {
        cover = coverToUpload
      }

      let partner = {
        ...formObject,
        whiteLabelId: user.whiteLabelId ? user.whiteLabelId : null,
        latLong,
        logo,
        cover,
        partnerTags: ParserTags(tags),
        partnersCodesItens: ParserPartnerCodesItens(partnersCodesItens)
      }
      if (editPartner && editPartner.id !== null) {
        partner = { ...partner, id: editPartner.id }
      }

      createPartner(partner)
        .then(async res => {
          if (partner.isUnity) {
            const unityData = {
              ...formObject,
              whiteLabelId: user.whiteLabelId ? user.whiteLabelId : null,
              slug: `${formObject.slug}-${slugify(formObject.neighborhood)}`,
              partnerId: res.id,
              latLong,
              logo,
              cover
            }

            await createUnity(unityData)

            setIsLoading(false)
          }
        })
        .catch(error => {
          console.log('createPartnerError', error)
          setOpenToast({
            open: true,
            message: 'Ocorreu algum erro ao salvar.',
            type: 'error'
          })
        })

      setIsLoading(false)

      if (partnerToEdit && partnerToEdit.id !== null) {
        history.replace('/unitieslist', {
          showToast: true,
          toastMessage: 'Parceiro Atualizado com Sucesso'
        })
      } else {
        history.replace('/partnerslist', {
          showToast: true,
          toastMessage: 'Parceiro Salvo com Sucesso'
        })
      }
    }
    /* else if (missInputs) {
      setOpenToast({
        open: true,
        message:
          'Existem campos obrigatórios sem preencher, favor verificar todos os campos',
        type: 'error',
      });
    } */
  }

  const checkIsEmpty = (key, value) => {
    if (obligatedList.filter(item => item.key === key).length > 0 && value.length === 0) {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: true,
            message: item.message,
            type: 'error'
          })
          return { ...item, showRed: true }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(true)
    } else {
      const newArr = obligatedList.map(item => {
        if (item.key === key) {
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
          return { ...item, showRed: false }
        }
        return { ...item }
      })
      setObligatedList(newArr)
      setMissInputs(false)
    }
  }

  const checkIsRed = key => {
    const obj = obligatedList.find(item => item.key === key)
    if (obj) return obj.showRed || false
  }

  return (
    <Grid container xs={12} style={{ padding: 15 }}>
      <Grid item xs={12} justify="center">
        {isLoading ? (
          <LinearProgress marginTop="30px" />
        ) : (
          <>
            <Context.Provider
              value={{
                latLong,
                setLatLong,
                iconLogo,
                newLogo,
                setNewLogo,
                iconCover,
                newCover,
                setNewCover,
                crop,
                cropCover,
                setCrop,
                setCropCover,
                logoToUpload,
                setLogoToUpload,
                coverToUpload,
                setCoverToUpload,
                tags,
                setTags,
                editPartner,
                responsibleList,
                formObject,
                setFormObject,
                setResponsibleList,
                classificationList,
                setClassificationList,
                setPartnersCodesItens,
                partnersCodesItens,
                openToast,
                setOpenToast,
                showTags,
                setShowTags,
                citys,
                showCitys
              }}
            >
              <ToastMessages />
              <form
                className="clube-form form-row"
                onSubmit={e => {
                  e.preventDefault()
                }}
              >
                {steps.step === 1 && (
                  <div className="col-12">
                    <CompanyForm
                      formType={!editPartner.id ? 'partner' : 'editPartner'}
                      editing={!editPartner.id || true}
                      checkValue={checkIsEmpty}
                      checkIsRed={checkIsRed}
                    />
                    <AddressForm />
                    <ContactForm hideCourtesyText={!!editPartner.id} />
                  </div>
                )}
                {steps.step === 2 && (
                  <div className="col-12">
                    <ContractForm checkValue={checkIsEmpty} checkIsRed={checkIsRed} />

                    <EventsTypeDiscounts />
                  </div>
                )}
                {steps.step === steps.maxStep && (
                  <PartnerData userWhiteLabel={user.whiteLabelId} userGroup={user.userGroup} />
                )}
                <div className="col-12">
                  <button
                    onClick={handleContinue}
                    type="button"
                    className="btn clube-button clube-blue"
                  >
                    {steps.step !== steps.maxStep ? 'Continuar' : 'Salvar'}
                  </button>
                </div>
              </form>
            </Context.Provider>

            <Context.Provider value={{ steps, setSteps }}>
              <FormNavigation />
            </Context.Provider>
          </>
        )}
      </Grid>
    </Grid>
  )
}

export default Partner
